export default __webpack_public_path__ + "static/media/waste_collection_jar.e9207dee.svg";